/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { observer } from 'mobx-react-lite'

import { useMobxStore } from '../../../state'
import { useEffect, useLayoutEffect, useMemo } from 'react'
import LoadingSpinner from '../../../components/LoadingSpinner'
import { ConfirmProfile } from './ConfirmProfile'
import { NewTeamRegistration } from './NewTeamRegistration'
import { NewPlayerRegistration } from './NewPlayerRegistration'
import { RegistrationSubmitted } from './RegistrationSubmitted'
import { TeamCreation } from './TeamCreation'
import { PlayerSearchTeam } from './PlayerSearchTeam'
import { RegistrationFailed } from './RegistrationFailed'

import soccerDefaultBg from './soccer_default_bg.png'
import hockeyDefaultBg from './hockey_default_bg.png'
import Helmet from 'src/components/Helmet'

const steps = {
  0: ConfirmProfile,
  1: NewTeamRegistration,
  2: RegistrationSubmitted,
  3: RegistrationFailed,
  4: PlayerSearchTeam,
  4.5: NewPlayerRegistration,
  5: TeamCreation,
}

export const Main = observer(() => {
  const {
    appStore: { setDarkMode, setLightMode },
    registrationTypes: { fetchTypes },
    registrationInvite: {
      state: { eventInfo, step, isLoadingStep, sports },
    },
  } = useMobxStore()

  useLayoutEffect(() => {
    fetchTypes()
  }, [])

  const Step = useMemo(() => steps[step], [step])

  const defaultBackgroundImage = useMemo(() => {
    const sport = sports.find(
      (sport) => sport?.sport_id === eventInfo?.sport_id
    )

    if (sport?.name === 'soccer') {
      return soccerDefaultBg
    }

    return hockeyDefaultBg
  }, [eventInfo?.sport_id, sports])

  const apiBackgroundImage = useMemo(() => {
    return eventInfo?.registration?.image?.full_path || defaultBackgroundImage
  }, [eventInfo?.registration?.image, defaultBackgroundImage])

  const isDarkMode = useMemo(
    () => eventInfo?.registration?.dark_theme,
    [eventInfo?.registration?.dark_theme]
  )

  useEffect(() => {
    if (!isDarkMode) {
      setLightMode()
    } else {
      setDarkMode()
    }
  }, [isDarkMode])

  return (
    <div
      css={css`
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-color: ${isDarkMode ? '#12161C' : colors.WHITE};
      `}
    >
      <Helmet title='Registration' />
      <div
        css={css`
          background-image: url(${apiBackgroundImage});
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
          width: 100vw;
          height: 360px;
        `}
      />
      <div
        css={css`
          background-color: ${isDarkMode ? '#21252A' : colors.WHITE};
          min-height: calc(100vh - 310px);
          margin-top: -50px;
          padding: 0 35px 35px 35px;
          border-radius: 16px 16px 0px 0px;

          box-shadow: 0px 10px 18px -2px rgba(16, 25, 40, 0.07);
          display: flex;
          flex-direction: column;
          display: flex;
          width: 1000px;
          padding: 40px;
          flex-direction: column;
          align-items: center;
          gap: 24px;
          flex-shrink: 0;

          @media (max-width: 768px) {
            width: 100%;
          }

          > * {
            color: #000;
          }
        `}
      >
        {isLoadingStep ? (
          <div
            css={css`
              display: flex;
              flex-direction: column;
              flex: 1;
              justify-content: center;
            `}
          >
            <LoadingSpinner />
          </div>
        ) : (
          <div
            css={css`
              width: 100%;
            `}
          >
            <Step isDarkMode={isDarkMode} />
          </div>
        )}
      </div>
    </div>
  )
})
